const getViews = () => (state) => state.views.views;
const getCurrentView = () => (state) => state.views.currentView;
const getViewRequestParams = () => (state) => state.views.viewRequestParams;
const getShowHideViewFields = () => (state) => state.views.showHideViewFields;
const getVisibleViewColumns = () => (state) => state.views.visibleViewColumns;

const viewsSelectors = {
  getViews,
  getCurrentView,
  getViewRequestParams,
  getShowHideViewFields,
  getVisibleViewColumns,
};

export default viewsSelectors;
